import {Injectable} from '@angular/core';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable, BehaviorSubject, Subject} from 'rxjs';
import {HttpParams} from '@angular/common/http';

export interface UserRequestParam {
    id: number;
    name: string;
    contact: string;
    username: string;
    email: string;

}

@Injectable()
export class UserService {

    constructor(private apiRequest: ApiRequestService,
                private appConfig: AppConfig) {
    }

    getUser(pageNumber: any, noOfRecords: any): Observable<any> {
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', noOfRecords);
        return this.apiRequest.get(this.appConfig.user_url, params);
    }

    getByUsername(id: number): Observable<any> {
        return this.apiRequest.get(this.appConfig.user_url + '/id/' + id);

    }

}
